import { fetchRSSFeed } from "../../../utils/rssParser";
import { fetchGoogleSheetRows } from "../Utils/leafHelpers";

export function flattenNodes(children, acc = []) {
  for (const c of (children || [])) {
    acc.push(c);
    if (c.type === "group" && c.children) flattenNodes(c.children, acc);
  }
  return acc;
}

export async function executeApiCall(call, vars = {}) {
  if (!call.url) return null;

  const resolveParamVal = (p) => {
    if (p.source === "variable") return vars[p.varName] !== undefined ? String(vars[p.varName]) : "";
    return p.literalValue || "";
  };

  // Normalize to unified params array, migrating legacy formats
  const params = call.params || (() => {
    const leg = [];
    (call.bodyVars || []).forEach(r => leg.push({ key: r.key || "", source: "variable", varName: r.varName || "", literalValue: "", type: "body" }));
    (call.queryVars || []).forEach(r => leg.push({ key: r.key || "", source: "variable", varName: r.varName || "", literalValue: "", type: "query" }));
    return leg;
  })();

  // Build URL with query params
  let url = call.url;
  const queryParams = params.filter(p => p.type === "query" && p.key);
  if (queryParams.length) {
    const qs = new URLSearchParams();
    queryParams.forEach(p => qs.append(p.key, resolveParamVal(p)));
    url += (url.includes("?") ? "&" : "?") + qs.toString();
  }

  // Build body
  let body = undefined;
  const method = call.method || "GET";
  if (method !== "GET") {
    const bodyParams = params.filter(p => p.type === "body" && p.key);
    if (bodyParams.length) {
      const obj = {};
      bodyParams.forEach(p => { obj[p.key] = resolveParamVal(p); });
      body = JSON.stringify(obj);
    } else if (call.body) {
      body = call.body;
    }
  }

  let headers = { "Content-Type": "application/json" };
  if (call.headersJSON) {
    try { headers = { ...headers, ...JSON.parse(call.headersJSON) }; } catch (_e) {}
  }
  (call.headers || []).forEach(h => { if (h.key) headers[h.key] = resolveParamVal(h); });
  if (method !== "GET" && !body && call.bodyJSON) {
    body = call.bodyJSON;
  }

  const res = await fetch(url, { method, headers, body });
  const json = await res.json();
  let result = json;
  if (call.responseKey) {
    for (const k of call.responseKey.split(".")) { if (result != null) result = result[k]; }
  }
  return result;
}


export async function executeDataSource(source, vars = {}) {
  if (!source || source.enabled === false) return null;
  const type = source.type || "api";

  if (type === "rss") {
    const items = await fetchRSSFeed(source.rssFeedUrl || "");
    return items.slice(0, source.maxItems || 20);
  }

  if (type === "googleSheets") {
    const rows = await fetchGoogleSheetRows(source.sheetUrl || "", source.sheetGid || "0");
    return rows;
  }

  return await executeApiCall(source, vars);
}